import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FaPlus, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

export default function FichasHeader() {
  const navigate      = useNavigate();
  const { pathname }  = useLocation();
  const { logout }    = useAuth();

  const isOrdenes = pathname.startsWith('/fichas/ordenes');

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <Header>
      <LogoBtn onClick={() => navigate('/')} aria-label="Ir al inicio">
        <Logo src="/img/logo/grupojaycom_logo.png" alt="Grupo Jaycom" />
      </LogoBtn>

      <Nav>
        <NavTab $active={!isOrdenes} onClick={() => navigate('/fichas')}>
          Fichas Técnicas
        </NavTab>
        <NavDivider />
        <NavTab $active={isOrdenes} onClick={() => navigate('/fichas/ordenes')}>
          Órdenes de Compra
        </NavTab>
      </Nav>

      <Actions>
        <NewBtn $orden={isOrdenes}
          onClick={() => navigate(isOrdenes ? '/fichas/ordenes/nueva' : '/fichas/nueva')}>
          <FaPlus size={12} />
          {isOrdenes ? 'Nueva orden' : 'Nueva ficha'}
        </NewBtn>
        <LogoutBtn onClick={handleLogout} title="Cerrar sesión">
          <FaSignOutAlt size={14} />
        </LogoutBtn>
      </Actions>
    </Header>
  );
}

/* ── Styled components ── */
const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.65rem 2rem;
  background: white;
  border-bottom: 3px solid var(--blue);
  flex-wrap: wrap;
  @media (max-width: 600px) { padding: 0.65rem 1rem; gap: 0.6rem; }
  @media print { display: none !important; }
`;

const LogoBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  &:hover { opacity: 0.8; }
`;

const Logo = styled.img`
  height: 34px;
  width: auto;
`;

const Nav = styled.nav`
  display: flex;
  align-items: stretch;
  border: 1.5px solid var(--border);
  border-radius: 4px;
  overflow: hidden;
  @media (max-width: 600px) { order: 10; width: 100%; }
`;

const NavTab = styled.button`
  padding: 0.4rem 1.1rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  border: none;
  background: ${p => p.$active ? 'var(--blue)' : 'transparent'};
  color: ${p => p.$active ? '#fff' : 'var(--gray)'};
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
  &:hover {
    background: ${p => p.$active ? 'var(--blue-dk)' : 'var(--blue-lt)'};
    color: ${p => p.$active ? '#fff' : 'var(--blue)'};
  }
`;

const NavDivider = styled.div`
  width: 1px;
  background: var(--border);
  flex-shrink: 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
`;

const NewBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: ${p => p.$orden ? 'var(--red)' : 'var(--blue)'};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.42rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s;
  &:hover { opacity: 0.85; }
`;

const LogoutBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid var(--border);
  border-radius: 4px;
  color: var(--gray);
  padding: 0.42rem 0.6rem;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { background: var(--red-lt); color: var(--red); border-color: var(--red); }
`;
